import React, { useState } from "react";
import "./EVOwnershipInput.css";

const options = [
  { label: "No",                       emoji: "🚫" },
  { label: "Yes: 1 vehicle",           emoji: "🚗" },
  { label: "Yes: more than 1 vehicle", emoji: "🚗🚗" },
];

export default function EVOwnershipInput({ nextStep, updateFormData }) {
  const [selected, setSelected] = useState("");

  const handleContinue = () => {
    if (!selected) {
      alert("Please tell us about any electric vehicles at your property.");
      return;
    }
    updateFormData({ evOwnership: selected });
    nextStep();
  };

  return (
    <div className="ev-ownership-container">
      <h2>Do you charge an electric vehicle at this property?</h2>
      <p className="intro-para">
        Electric vehicles are a great complement to solar PV — charging from your own
        generated electricity significantly boosts your self-consumption and return on
        investment.
      </p>
      <div className="ev-options">
        {options.map(({ label, emoji }) => (
          <button
            key={label}
            type="button"
            className={selected === label ? "ev-btn selected" : "ev-btn"}
            onClick={() => setSelected(label)}
          >
            {emoji} {label}
          </button>
        ))}
      </div>
      <button className="continue-button" onClick={handleContinue}>
        Continue
      </button>
    </div>
  );
}
